<script setup lang="ts">
withDefaults(defineProps<{ wordmark?: boolean; light?: boolean; size?: number }>(), {
  wordmark: true,
  light: false,
  size: 43,
})
</script>

<template>
  <NuxtLink to="/" class="logo" :class="{ 'logo--light': light }" aria-label="Regotiate home">
    <img src="/images/brand/logo-mark-red.svg" alt="" :width="size" :height="size" />
    <span v-if="wordmark" class="logo__word">Regotiate</span>
  </NuxtLink>
</template>

<style scoped>
.logo {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.logo img {
  border-radius: 50%;
}

.logo__word {
  font-size: 9px;
  line-height: 1;
  font-weight: 600;
  letter-spacing: 0.55em;
  text-transform: uppercase;
  color: var(--gray-900);
}

.logo--light .logo__word {
  color: var(--white);
}
</style>
